import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import { makeStyles } from "@material-ui/core/styles";
import BajaMultiple from "../../BajaMultiple";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ListadoOrdenesCorteAcumuladas() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ORDENES_CORTE = process.env.REACT_APP_URL_ORDENES_CORTE;
  const URL_ARTICULOS_ORDENES_CORTE =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_EXPLOSION = process.env.REACT_APP_URL_EXPLOSION;
  const URL_EXPLOSION_GLOBAL = process.env.REACT_APP_URL_EXPLOSION_GLOBAL;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  // Agregar Tela a Orden de Produccion
  const URL_TELAS_ORDENES_CORTE = process.env.REACT_APP_URL_TELAS_ORDENES_CORTE;
  const URL_TELAS_ORDENES_CORTES_ACUMULADOS =
    process.env.REACT_APP_URL_TELAS_ORDENES_CORTES_ACUMULADOS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_HABILITACION_ORDENES_CORTES = process.env.REACT_APP_URL_HABILITACION_ORDENES_CORTES;
  const URL_DETALLE_HABILITACION_ORDENES_CORTES = process.env.REACT_APP_URL_DETALLE_HABILITACION_ORDENES_CORTES;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
  const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];
  const [ordenesCorte, setOrdenesCorte] = useState([]);

  const [inventarios, setInventarios] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [selectedCortado, setSelectedCortado] = useState("No");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [articulosEdit, setArticulosEdit] = useState([]);
  const [total_piezas, setTotalPiezas] = useState(0);

  const classes = useStyles();

  const [validaBoton, setValidaBoton] = useState(true);

  const [fechaTelas, setFechaTelas] = useState(endDate);
  const [observacionesTelas, setObservacionesTelas] = useState("NA");
  const [observacionesTelasPDF, setObservacionesTelasPDF] = useState("");
  const [selectedOrdenCorte, setSelectedOrdenCorte] = useState("");
  const [selectedOrdenCorteNumero, setSelectedOrdenCorteNumero] = useState("");
  const [totalMetros, setTotalMetros] = useState("");
  const [totalKilos, setTotalKilos] = useState("");
  const [cantidadAgrupado, setCantidadAgrupado] = useState([]);
  const [articulosOrden, setArticulosOrden] = useState([]);
  const [rollosTotales, setRollosTotales] = useState(0);
  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [modalTelas, setModalTelas] = useState(false);
  const toggleTelas = () => setModalTelas(!modalTelas);

  const [explosion, setExplosion] = useState([]);
  const [idEdit, setIdEdit] = useState("");
  const [numero_pedido, setNumeroPedido] = useState("");
  const [modalExplosion, setModalExplosion] = useState(false);
  const toggleExplosion = () => setModalExplosion(!modalExplosion);

  const [telasDevolucion, setTelasDevolucion] = useState("");
  const [idsInventario, setIdsInventario] = useState("");
  const [selectedOrdenCorteDev, setSelectedOrdenCorteDev] = useState("");
  const [selectedOrdenCorteNumeroDev, setSelectedOrdenCorteNumeroDev] =
    useState("");
  const [modalTelasDev, setModalTelasDev] = useState(false);
  const toggleTelasDev = () => setModalTelasDev(!modalTelasDev);
  const [rollosTotalesDev, setRollosTotalesDev] = useState(0);

    const [statusTelaEdit, setStatusTelaEdit] = useState("");
    const [modalStatusEdit, setModalStatusEdit] = useState(false);
    const toggleStatusEdit = () => setModalStatusEdit(!modalStatusEdit);

    const [observacionesEdit, setObservacionesEdit] = useState("");
    const [modalObservacionesEdit, setModalObservacionesEdit] = useState(false);
    const toggleObservacionesEdit = () => setModalObservacionesEdit(!modalObservacionesEdit);

        const [entregaHabilitacion, setEntregaHabilitacion] = useState(false);
    const [habilitacion, setHabilitacion] = useState([]);

    const [idProcesosSalidaHab, setIdProcesosSalidaHab] = useState("");
    const [idCorteHab, setIdCorteHab] = useState("");
    const [idPedidoHab, setIdPedidoHab] = useState("");
    const [idProveedorHab, setIdProveedorHab] = useState("");
    const [fechaHab, setFechaHab] = useState("");
    const [observacionesHab, setObservacionesHab] = useState("");

    const [modalHabilitacion, setModalHabilitacion] = useState(false);
    const toggleHabilitacion = () => setModalHabilitacion(!modalHabilitacion);
    const [inputFieldsHabilitacion, setInputFieldsHabilitacion] = useState([
      {
        id: uuidv4(),
        idHabilitacion: "",
        cantidad: 0,
      },
    ]);

      const [editHab, setEditHab] = useState([]);
        const [modalEditHab, setModalEditHab] = useState(false);
        const toggleEditHab = () => setModalEditHab(!modalEditHab);


    
  const [modalTelasConsumo, setModalTelasConsumo] = useState(false);
  const toggleTelasConsumo = () => setModalTelasConsumo(!modalTelasConsumo);
    const [inputFieldsAnteriorConsumo, setInputFieldsAnteriorConsumo] = useState([]);
  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idInventarioTelas: "",
      telas: "",
      idTela: "",
      unidad: "",
      colores: "",
      idColor: "",
      cantidadOriginal: 0,
      cantidad: 0,
      idArticulo: "",
      compras: "",
      telasOC: "",
      telaCodigo: "",
      telaNombre: "",
      telaColor: "",
    },
  ]);

  const [inputFieldsAnterior, setInputFieldsAnterior] = useState([]);

  useMemo(() => {
   axios
  .get(
    `${URL_ORDENES_CORTE}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
    {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    }
  )
  .then((response) => {
    let allOrdenes = response.data;

    // Transformamos a arrayTabla
    let arrayTabla = allOrdenes
      .sort((a, b) => (a.idOrdenesCorte < b.idOrdenesCorte ? 1 : -1))
      .map((a) => {
        return {
          _id: a._id,
          numero: a.idOrdenesCorte,
          fecha: a.pedidos[0].fecha,
          pedido: a.pedidos[0].idPedido,
          idPedidos: a.pedidos[0]._id,
          cortado: a.cortado,
          cliente: a.pedidos[0].clientes[0].nombre_comercial,
          idCliente: a.pedidos[0].clientes[0]._id,
          articulo: a.articulos[0].codigo,
          // articulo: "Ref: " + a.articulos[0].codigo + " / Desc: " + a.articulos[0].descripcion,
          articuloCodigo: a.articulos[0].codigo,
          articuloDescripcion: a.articulos[0].descripcion,
          idArticulo: a.articulos[0]._id,
          fechaCancelacion: a.pedidos[0].fecha_cancelacion,
          total_piezas: a.cantidad,
          observaciones: a.pedidos[0].observaciones,
          observacionesPedido: a.pedidos[0].observaciones,
          is_active: a.is_active,
          statusTela: a.statusTela,
          pedidoEditado: a.pedidos[0].editado,
          corteExterno: a.corteExterno,
        };
      })
      .filter((el) => el != null);

    // Agrupamos por idPedidos
    let agrupado = arrayTabla.reduce((acc, orden) => {
      if (!acc[orden.idPedidos]) {
        acc[orden.idPedidos] = {
          idPedidos: orden.idPedidos,
          pedido: orden.pedido,
          cliente: orden.cliente,
          idCliente: orden.idCliente,
          fechaCancelacion: orden.fechaCancelacion,
          observaciones: orden.observaciones,
          pedidoEditado: orden.pedidoEditado,
          fecha: orden.fecha,
          ordenes: [],
        };
      }
      acc[orden.idPedidos].ordenes.push(orden);
      return acc;
    }, {});

    // Convertimos a array final
    let dataFinal = Object.values(agrupado);

    setOrdenesCorte(allOrdenes);
    setComments(dataFinal);
  })
  .catch((err) => {
    console.log(err);
  });


    
  }, [selectedFechaInicio, selectedFechaFin]);
console.log("hola", comments)
useEffect(() => {
    axios
      .get(`${URL_INVENTARIOS_TELAS}Existencia`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInventarios = response.data;
        setInventarios(allInventarios);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
          axios
      .get(URL_HABILITACION, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allHabilitacion = response.data;
        // Array para pagination
        let arrayTabla = allHabilitacion
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              nombre: a.nombre,
              unidad: a.unidad,
              observaciones: a.observaciones,
              descripcion: a.descripcion,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setHabilitacion(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente >= a.idCliente) 
        // &&
        // (selectedArticulo == 0 || selectedArticulo >= a.idArticulo)
        // &&
        // (selectedCortado == 0 || selectedCortado >= a.cortado)
      ) {
        return [a.numero, a.fecha, a.pedido];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Ordenes de Corte Acumuladas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Pedido"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Ordenes-Corte.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente >= a.idCliente) 
        // &&
        // (selectedArticulo == 0 || selectedArticulo >= a.idArticulo)
        // &&
        // (selectedCortado == 0 || selectedCortado >= a.cortado)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Pedido: a.pedido,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoOrdenesCorteAcumuladas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoOrdenesCorteAcumuladas",
        sheetFilter: ["Numero", "Fecha", "Pedido"],
        sheetHeader: ["Numero", "Fecha", "Pedido"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == 0 || selectedCliente >= a.idCliente) 
        // &&
        // (selectedArticulo == 0 || selectedArticulo >= a.idArticulo)&&
        // (selectedCortado == 0 || selectedCortado >= a.cortado)
      ) {
        return [a.numero, a.fecha, a.pedido];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Ordenes de Corte Acumuladas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Pedido"]],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ordenes Corte",
          email: mailTo,
          fileName: "ListadoOrdenesCorteAcumuladas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ordenes de Corte Acumuladas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Pedido", field: "pedido", sortable: true },
    // { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha Creacion", field: "fecha", sortable: false },
    { name: "Cliente", field: "cliente", sortable: false },
    // { name: "Articulo", field: "articulo", sortable: false },
    // { name: "Status Tela", field: "statusTela", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: false },
    { name: "Fecha Cancelacion", field: "fechaCancelacion", sortable: false },
    // { name: "Cantidad", field: "total_piezas", sortable: false },
    // { name: "Cortado", field: "cortado", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
    // { name: "Tela", field: "Tela", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.fecha.toLowerCase().includes(search.toLowerCase()) ||
          // comment.articulo.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          // comment.statusTela.toLowerCase().includes(search.toLowerCase()) ||
          comment.fechaCancelacion
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          // comment.cortado.toLowerCase().includes(search.toLowerCase()) ||
          comment.numero.toString().includes(search) ||
          // comment.total_piezas.toString().includes(search) ||
          comment.pedido.toString().includes(search)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }
    // if (selectedArticulo) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idArticulo.includes(selectedArticulo)
    //   );
    // }
    // if (selectedCortado) {
    //   computedComments = computedComments.filter((e) =>
    //     e.cortado.includes(selectedCortado)
    //   );
    // }
    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_piezas" &&
      sorting.field != "numero" &&
      sorting.field != "pedido"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "numero" ||
        sorting.field == "total_piezas" ||
        sorting.field == "pedido")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "numero" ||
        sorting.field == "total_piezas" ||
        sorting.field == "pedido")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedCliente,
    // selectedArticulo,
    // selectedCortado,
  ]);

  let totalCantidad = 0;
  let totalCortado = 0;
  let totalPendCortar = 0;

async function PDFOC(
  numero,
  cliente,
  fecha,
  pedido,
  idPedidos,
  articuloCodigo,
  articuloDescripcion,
  idArticulo,
  totalPiezas,           // (no se usa directamente, calculamos de la tabla)
  observaciones,
  idPDFOC
) {
  // === Helpers: sanitizar / números / utilidades ===
  const s = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return "";
    return typeof v === "string" ? v : String(v);
  };
  const sn = (v, def = 0) => {
    if (v === null || v === undefined) return def;
    if (typeof v === "string" && v.trim().toUpperCase() === "NA") return def;
    const n = Number(v);
    return Number.isFinite(n) ? n : def;
  };

  const getFirstName  = (arr) => s(arr?.[0]?.name);
  const getFirstAlias = (arr) => s(arr?.[0]?.alias);
  const getFirstId    = (arr) => s(arr?.[0]?._id);

  // Orden estándar de tallas (mismo criterio que el 2° PDF)
  const ORDEN_TALLAS = [
    "2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","3XG",
    "2XG","3XG","4XG","5XG",
    "VARIOS",
    "2",
    "4",
    "6",
    "8","9","10","11","12","13","14","15","16","17","18","19","20",
    "21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40",
    "41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"
  ];

  const sortTalla = (a, b) => {
    const ia = ORDEN_TALLAS.indexOf(a);
    const ib = ORDEN_TALLAS.indexOf(b);
    return (ia === -1 ? Number.POSITIVE_INFINITY : ia) - (ib === -1 ? Number.POSITIVE_INFINITY : ib);
  };

  // Cargar imagen a dataURL (para bordados)
  const getImageAsDataURL = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = reject;
      img.src = url;
    });

  try {
    // === Trae artículos de la ORDEN por pedido ===
    const { data: allArticulosOrdenCorte } = await axios.get(
      `${URL_ARTICULOS_ORDENES_CORTE}/pedido/${idPedidos}`,
      { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
    );

    // === jsPDF base con márgenes/flujo como el 2° PDF ===
    const doc = new jsPDF();
    const pageWidth    = doc.internal.pageSize.getWidth();
    const pageHeight   = doc.internal.pageSize.getHeight();
    const marginLeft   = 20;
    const marginTop    = 20;
    const marginBottom = 20;

    let currentY = 68;
    const ensureRoom = (needed) => {
      if (currentY + needed > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
    };

    // === Logo centrado (mismo patrón) ===
    const logo = new Image();
    logo.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    await new Promise((resolve) => {
      logo.onload = () => {
        const scale = 30 / logo.height;
        doc.addImage(
          logo,
          "PNG",
          (pageWidth - logo.width * scale) / 2,
          10,
          logo.width * scale,
          logo.height * scale
        );
        resolve();
      };
    });

    // === Encabezado (alineado al 2° PDF) ===
    doc.setFontSize(12);
    doc.setFont(undefined, "normal");
    doc.text(`Orden de Producción # ${s(numero)} — Fecha: ${s(fecha)}`, marginLeft, 45);
    doc.text(`Cliente: ${s(cliente)} — Pedido: ${s(pedido)}`, marginLeft, 50);
    if (s(articuloCodigo) || s(articuloDescripcion)) {
      doc.text(`Modelo: ${s(articuloCodigo)} ${s(articuloDescripcion)}`.trim(), marginLeft, 55);
    }
    if (s(observaciones)) {
      const maxWidth = pageWidth - marginLeft * 2;
      const obsLines = doc.splitTextToSize(`Observaciones: ${s(observaciones)}`, maxWidth);
      doc.text(obsLines, marginLeft, 60);
    }

    // === Agrupar como el 2° PDF: Sucursal → Área → (Artículo/Modelo)
    const sucursalMap = {};
    allArticulosOrdenCorte.forEach((a) => {
      const sucursal   = getFirstAlias(a.sucursales) || getFirstId(a.sucursales) || "Sin Sucursal";
      const areaNombre = getFirstName(a.areasClientes) || getFirstId(a.areasClientes) || "Sin Área";
      const articulo   = s(a.articulos?.[0]?.descripcion) || s(a.articulos?.[0]?.codigo) || "Sin Artículo";

      const key = `${sucursal}||${areaNombre}||${articulo}`;
      if (!sucursalMap[key]) sucursalMap[key] = [];
      sucursalMap[key].push(a);
    });

    let totalPiezasGlobal = 0;

    // === Por cada grupo, pintar subtítulo y tabla (idéntico al enfoque del 2° PDF) ===
    for (const clave in sucursalMap) {
      const grupo = sucursalMap[clave];
      const [sucursal, areaNombre, articuloNombre] = clave.split("||");

      // Encabezado de grupo
      doc.setFont(undefined, "bold");
      doc.setFontSize(11);
      ensureRoom(18);
      doc.text(`Sucursal: ${s(sucursal)}`, marginLeft, currentY); currentY += 5;
      doc.text(`Área: ${s(areaNombre)} — Modelo: ${s(articuloNombre)}`, marginLeft, currentY); currentY += 5;

      // (Opcional) Tela si viene anidada
      const telaNombre = s(grupo?.[0]?.articulosPedido?.[0]?.tela);
      const telaComp = s(grupo?.[0]?.articulosPedido?.[0]?.composicion);
      const tela = telaNombre && telaComp
        ? `${telaNombre} - ${telaComp}`
        : telaNombre || telaComp;
      if (tela) {
        doc.text(`Tela: ${tela}`, marginLeft, currentY);
        currentY += 5;
      }

      // === Build de tabla: columnas por tallas ordenadas; filas por color; celdas “cantidad (variante)” ===
      const agrupadoPorColor = {};
      const tallasSet = new Set();

      grupo.forEach((a) => {
        const color    = getFirstName(a.colores) || "Sin Color";
        const talla    = s(a.tallas?.[0]?.name?.trim()) || "Sin Talla";
        const variante = s(a.tallas?.[0]?.variantesTallas?.[0]?.name?.trim());
        const detalle  = variante ? `(${variante})` : "";

        if (!agrupadoPorColor[color]) agrupadoPorColor[color] = {};
        if (!agrupadoPorColor[color][talla]) agrupadoPorColor[color][talla] = [];

        agrupadoPorColor[color][talla].push({ cantidad: sn(a.cantidad, 0), detalle });
        tallasSet.add(talla);
      });

      const tallasOrdenadas = Array.from(tallasSet).sort(sortTalla);
      const head = [["Color", ...tallasOrdenadas, "Total"]];
      const body = [];

      Object.keys(agrupadoPorColor).forEach((color) => {
        let totalColor = 0;
        const row = [s(color)];
        tallasOrdenadas.forEach((t) => {
          const celdas = agrupadoPorColor[color][t] || [];
          let texto = "";
          let subtotal = 0;
          celdas.forEach(({ cantidad, detalle }) => {
            texto += `${sn(cantidad, 0)}${detalle ? " " + detalle : ""}\n`;
            subtotal += sn(cantidad, 0);
          });
          row.push(texto.trim());
          totalColor += subtotal;
        });
        row.push(totalColor);
        body.push(row);
      });

      // Totales por grupo (piezas)
      const totalPiezasGrupo = body.reduce((acc, row) => acc + (parseInt(row[row.length - 1]) || 0), 0);
      totalPiezasGlobal += totalPiezasGrupo;

      // Pintar tabla con los mismos estilos del 2° PDF
      doc.autoTable({
        head,
        body,
        startY: currentY - 3,
        styles: {
          fontSize: 9,
          cellPadding: 0.8,
          valign: "middle",
          halign: "center",
          cellWidth: "wrap",
          overflow: "linebreak",
        },
        headStyles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: "bold" },
        margin: { left: marginLeft, right: marginLeft },
      });

      currentY = doc.autoTable.previous.finalY + 5;

      // === Bordados (una sola vez por grupo si existen en el primer ArticuloPedido) ===
      const primer = grupo.find((a) => Array.isArray(a.articulosPedido?.[0]?.bordados) && a.articulosPedido[0].bordados.length > 0);
      const bordados = primer?.articulosPedido?.[0]?.bordados || [];

      if (bordados.length) {
        doc.setFont(undefined, "bold");
        doc.setFontSize(10);
        ensureRoom(12);
        doc.text("Bordados:", marginLeft, currentY);
        currentY += 1;

        let currentX = marginLeft;
        let maxYInRow = 0;
        const imageMargin = 5;
        // x3: bordados 3 veces más grandes (2026-06)
        const maxImageHeight = 10 * 3;
        const maxImageWidth  = 15 * 3;

        for (const b of bordados) {
          try {
            const publicId = s(b.public_id);
            if (!publicId) continue;
            const url = `https://res.cloudinary.com/lynqro/image/upload/${publicId}`;
            const dataUrl = await getImageAsDataURL(url);

            const img = new Image();
            img.src = dataUrl;
            await new Promise((resolve) => {
              img.onload = () => {
                const ratio = Math.min(maxImageWidth / img.width, maxImageHeight / img.height);
                const imgW = img.width * ratio;
                const imgH = img.height * ratio;

                // salto horizontal si no cabe
                if (currentX + imgW > pageWidth - marginLeft) {
                  currentX = marginLeft;
                  currentY += maxYInRow + 15;
                  maxYInRow = 0;
                  ensureRoom(imgH + 12);
                }

                doc.addImage(dataUrl, "PNG", currentX, currentY, imgW, imgH);
                doc.setFont(undefined, "normal");
                doc.setFontSize(10);
                const obs = s(b.observacion);
                if (obs) doc.text(obs, currentX, currentY + imgH + 2, { maxWidth: imgW });

                maxYInRow = Math.max(maxYInRow, imgH + (obs ? 10 : 0));
                currentX += imgW + imageMargin;
                resolve();
              };
            });
          } catch (e) {
            console.warn("No se pudo cargar bordado:", e);
          }
        }

        currentY += maxYInRow + 10;
      }
    }

    // === Observaciones generales al final (mismo flujo) ===
    if (s(observaciones)) {
      ensureRoom(20);
      doc.setFont(undefined, "bold");
      doc.setFontSize(11);
      doc.text("Observaciones:", marginLeft, currentY);
      currentY += 6;

      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      const maxWidth = pageWidth - marginLeft * 2;
      const textLines = doc.splitTextToSize(s(observaciones), maxWidth);

      const lineHeightFactor = 1.15;
      const lineHeight = doc.getFontSize() * lineHeightFactor * (doc.internal.scaleFactor ? 1 / doc.internal.scaleFactor : 1);
      const blockHeight = textLines.length * lineHeight;

      if (currentY + blockHeight > pageHeight - marginBottom) {
        doc.addPage();
        currentY = marginTop;
      }
      doc.text(textLines, marginLeft, currentY);
      currentY += blockHeight + 10;
    }

    // === Resumen general (solo piezas; si ocupas dinero, agrégalo como en el 2° PDF) ===
    ensureRoom(20);
    doc.setFont(undefined, "bold");
    doc.setFontSize(12);
    doc.text("RESUMEN GENERAL", marginLeft, currentY); currentY += 6;
    doc.text(`Piezas: ${sn(totalPiezasGlobal, 0)}`, marginLeft, currentY); currentY += 6;

    // === Firma (idéntico estilo) ===
    const signatureGap = 30;
    const lineWidth = 80;
    ensureRoom(signatureGap + 12);
    currentY += signatureGap;
    doc.setFont(undefined, "bold");
    doc.text("FIRMA DE CONFORMIDAD", pageWidth / 2, currentY, { align: "center" });
    currentY += 12;
    const lineStartX = (pageWidth - lineWidth) / 2;
    const lineEndX = lineStartX + lineWidth;
    doc.setDrawColor(0);
    doc.line(lineStartX, currentY, lineEndX, currentY);

    // === Abrir ===
    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDF (Producción):", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
}


function editOrden(
  id,
  observaciones
) {
  setIdEdit(id);
  setObservacionesEdit(observaciones);
  toggleObservacionesEdit();
}
function saveObservacionesEdit(event) {
  event.preventDefault();
  axios
  .patch(
    `${URL_ORDENES_CORTE}/${idEdit}`,
    {
      observaciones: observacionesEdit
    },
    {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    }
  )
  .then((response) => {
    axios
      .post(
        URL_LOGS,
        {
          tipo: "Editar Observaciones",
          detalle: `Corte ${idEdit}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem(
              "app_token"
            )}`,
          },
        }
      )
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Listo",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  })
  .catch((error) => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error.response.data}`,
    });
    console.log(error);
  });
}

function statusEdit(
  id,
  statusTela
) {
  setIdEdit(id);
  setStatusTelaEdit(statusTela);
  toggleStatusEdit();
}
function saveStatusEdit(event) {
  event.preventDefault();
  axios
  .patch(
    `${URL_ORDENES_CORTE}/${idEdit}`,
    {
      statusTela: statusTelaEdit
    },
    {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    }
  )
  .then((response) => {
    axios
      .post(
        URL_LOGS,
        {
          tipo: "Editar Status",
          detalle: `Corte ${idEdit}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem(
              "app_token"
            )}`,
          },
        }
      )
      .then(() => {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Listo",
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  })
  .catch((error) => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error.response.data}`,
    });
    console.log(error);
  });
}

  async function requisicion(id, numero) {
    setExplosion([]);
    toggleProgreso();
    setIdEdit(id);
    setNumeroPedido(numero);
    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async (response) => {
        let allArticulosPedido = response.data;
        let arrayTabla = await allArticulosPedido
          .map((a) => {
            return {
              id: a._id,
              activo: a.is_active,
              articulos: a.articulosPedido[0].articulos[0]._id,
              articulosCodigo:
                a.articulosPedido[0].articulos[0].codigo +
                " / " +
                a.articulosPedido[0].articulos[0].codigoCliente,
              colores: a.articulosPedido[0].colores[0]._id,
              coloresName: a.articulosPedido[0].colores[0].name,
              cantidad: a.cantidad,
              surtido: a.articulosPedido[0].surtido,
              pendiente_surtir: a.articulosPedido[0].pendiente_surtir,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let data = Object.values(arrayTabla);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["articulos"];
          groups[val] = groups[val] || {
            articulos: item.articulos,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].articulos = item.articulos;
          groups[val].articulosCodigo = item.articulosCodigo;
          return groups;
        }, []);

        let dataFinal = Object.values(agrupado);

        let agrupadoColores = data.reduce(function (groups, item) {
          const val = item["articulos"] + item["colores"];
          groups[val] = groups[val] || {
            articulos: item.articulos,
            colores: item.colores,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].articulos = item.articulos;
          groups[val].articulosCodigo = item.articulosCodigo;
          groups[val].colores = item.colores;
          groups[val].coloresName = item.coloresName;
          return groups;
        }, []);

        let dataFinalColores = Object.values(agrupadoColores);

        let temp2 = [];

        let exp = await dataFinal.map((a) => {
          axios
            .get(`${URL_EXPLOSION}Articulo/${a.articulos}`, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allExplosion = response.data;
              let arrayExp = allExplosion
                .map((b) => {
                  if (b.habilitacion != "") {
                    temp2.push({
                      articulos: a.articulos,
                      articulosCodigo: a.articulosCodigo,
                      material: b.habilitacion[0].nombre  + " " + b.habilitacion[0].descripcion,
                      cantidadTotal: b.cantidad * a.cantidad,
                      cantidad: b.cantidad,
                      colores: "NA",
                      coloresName: "NA",
                    });
                  }
                })
                .filter(function (el) {
                  return el != null;
                });
            })
            .catch((err) => {
              console.log(err);
            });
        });

        let expColores = await dataFinalColores.map((a) => {
          axios
            .get(`${URL_EXPLOSION}Articulo/${a.articulos}`, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((response) => {
              let allExplosion = response.data;
              let arrayExp = allExplosion
                .map((b) => {
                  if (b.telas != "") {
                    temp2.push({
                      articulos: a.articulos,
                      articulosCodigo: a.articulosCodigo,
                      material: b.telas[0].nombre,
                      cantidadTotal: b.cantidad * a.cantidad,
                      cantidad: b.cantidad,
                      colores: a.colores,
                      coloresName: a.coloresName,
                    });
                  }
                })
                .filter(function (el) {
                  return el != null;
                });
            })
            .catch((err) => {
              console.log(err);
            });
        });
        setExplosion(temp2);
        setTimeout(() => {
          setModalProgreso(false);
          toggleExplosion();
        }, 3500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function telasCortes(id, numero) {
    toggleProgreso()
    axios
      .get(`${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/ordenCorte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInputFieldsAnterior = response.data;
        let tablaTelas = allInputFieldsAnterior.map((a) => {
          return {
            articulo:
              a.articulos[0].codigo +
              " / " +
              a.articulos[0].codigoCliente +
              " / " +
              a.articulos[0].descripcion,
            tela: a.telas[0].nombre,
            color: a.colores[0].name,
            unidad: a.telas[0].unidad,
            cantidad: a.cantidad,
            telaNombre: a.telas[0].codigo + " / " + a.telas[0].nombre + " / " + a.colores[0].name
          };
        });
        let dataFinal = Object.values(tablaTelas);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["tela"] + item["color"];
          groups[val] = groups[val] || {
            tela: item.tela,
            color: item.color,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].tela = item.tela;
          groups[val].unidad = item.unidad;
          groups[val].color = item.color;
          groups[val].articulo = item.articulo;
          groups[val].telaNombre = item.telaNombre;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);

        setInputFieldsAnterior(agrupadoValues);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            totalCantidad = totalCantidad + a.cantidad;
            totalCortado = totalCortado + a.cortado;
            totalPendCortar = totalPendCortar + a.pendiente_cortar;
            return {
              id: a._id,
              articuloNombre: a.articulos[0].codigo + " / " + a.articulos[0].descripcion,
              idArticulo: a.articulos[0]._id,
              cantidad: a.cantidad,
              cortado: a.cortado,
              pendiente_cortar: a.pendiente_cortar,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        const data = Object.values(arrayTabla);
        setArticulosOrden(data);

        let agrupado = data.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].articuloNombre = item.articuloNombre;
          return groups;
        }, []);
        let dataFinalAgru = Object.values(agrupado);
        setArticulosUnicos(dataFinalAgru);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedOrdenCorte(id);
    setSelectedOrdenCorteNumero(numero);
    setTimeout(() => {
      toggleTelas();
      setModalProgreso(false)
    }, 2000);
  }

  function telasCortesDev(id, numero) {
    setIdsInventario([]);
    axios
      .get(`${URL_INVENTARIOS_TELAS}/cortesDevolucion/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTelasDevolucion = res.data;
        setTelasDevolucion(allTelasDevolucion);
        let result = allTelasDevolucion.map(({ _id }) => _id);
        setIdsInventario(result);
      })
      .catch((err) => {
        console.log(err);
      });
    setSelectedOrdenCorteDev(id);
    setSelectedOrdenCorteNumeroDev(numero);
    toggleTelasDev();
  }

  function BuscaRolloDev(id, event) {
    if (event.target.value.length >= 24) {
      if (idsInventario.includes(event.target.value)) {
        if (
          inputFields.filter((e) => e.idInventarioTelas == event.target.value)
            .length > 0
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El rollo ya fue escaneado!",
            showConfirmButton: false,
          });
          const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
              i.idInventarioTelas = "";
            }
            return i;
          });
          setInputFields(newInputFields);
        } else {
          telasDevolucion.map((a) => {
            if (a._id == event.target.value) {
              let telasDevolucion = a._id;
              let tela = a.tela;
              let idTela = a.idTela;
              let unidadTela = a.unidadTela;
              let color = a.color;
              let cantidadOriginal = a.cantidad;
              let cantidad = a.cantidad;
              let compras = a.compras;
              let telasOC = a.telasOC;
              let telaCodigo = a.telaCodigo;
              let telaNombre = a.telaNombre;
              let telaColor = a.telaColor;
              handleChangeInputArticuloDev(
                id,
                telasDevolucion,
                tela,
                idTela,
                unidadTela,
                color,
                cantidad,
                cantidadOriginal,
                compras,
                telasOC,
                telaCodigo,
                telaNombre,
                telaColor
              );
            }
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El rollo no pertenece al pedido o fue devuelto previamente!",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.idInventarioTelas = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      }
    } else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  const handleChangeInputArticuloDev = (
    id,
    telasDevolucion,
    tela,
    idTela,
    unidadTela,
    color,
    cantidad,
    cantidadOriginal,
    compras,
    telasOC,
    telaCodigo,
    telaNombre,
    telaColor
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idInventarioTelas = telasDevolucion;
        i.telas = tela;
        i.idTela = idTela;
        i.unidad = unidadTela;
        i.colores = color;
        i.cantidad = cantidad;
        i.cantidadOriginal = cantidadOriginal;
        i.compras = compras;
        i.telasOC = telasOC;
        i.telaCodigo = telaCodigo;
        i.telaNombre = telaNombre;
        i.telaColor = telaColor;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesDev();
    handleAddFields();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotalesDev();
  };

  function ActualizaTotalesDev() {
    let mts = inputFields.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFields.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["colores"] + item["idTela"];
      groups[val] = groups[val] || {
        colores: item.colores,
        idTela: item.idTela,
        cantidad: 0,
      };
      groups[val].id = item.id;
      groups[val].cantidad += item.cantidad;
      groups[val].colores = item.colores;
      groups[val].idTela = item.idTela;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);

    let tr = 0;
    inputFields.map((a) => {
      if (a.idTela != "") {
        return (tr = tr + 1);
      }
    });
    setRollosTotalesDev(tr);
  }

  const saveTelasDev = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();

    let totalRollos = inputFields.length + cantidadAgrupado.length;

    try {
      inputFields.map((a) => {
        if (a.idInventarioTelas != "") {
          if (a.cantidad != a.cantidadOriginal) {
            axios
              .patch(
                `${URL_INVENTARIOS_TELAS}/${a.idInventarioTelas}`,
                {
                  cantidad:
                    parseFloat(a.cantidadOriginal) - parseFloat(a.cantidad),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                axios
                  .post(
                    `${URL_INVENTARIOS_TELAS}`,
                    {
                      cantidad: a.cantidad,
                      captura: 1,
                      produccion: "No",
                      telas: a.idTela,
                      colores: a.colores,
                      compras: a.compras,
                      telasOC: a.telasOC,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((data) => {
                    totalRollos = totalRollos - 1;
                    QRGen(
                      data.data._id,
                      a.telaCodigo,
                      a.telaNombre,
                      a.telaColor,
                      a.cantidad,
                      a.unidad
                    );
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Devolucion",
                            detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          } else {
            axios
              .patch(
                `${URL_INVENTARIOS_TELAS}/devolucionCorte/${a.idInventarioTelas}`,
                {},
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Devolucion",
                        detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        } else {
          totalRollos = totalRollos - 1;
          if (totalRollos == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Crear Devolucion",
                  detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        }
      });

      // Pegamos a Devoluciones Acumulado

      cantidadAgrupado.map((w) => {
        if (w.idTela != "") {
          axios
            .patch(
              `${URL_INVENTARIOS_TELAS}DevolucionCorte2`,
              {
                ordenesCorte: selectedOrdenCorteDev,
                total_cantidad: w.cantidad,
                idColor: w.colores,
                idTela: w.idTela,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              totalRollos = totalRollos - 1;
              if (totalRollos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Devolucion",
                      detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        } else {
          totalRollos = totalRollos - 1;
          if (totalRollos == 0) {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Crear Devolucion",
                  detalle: `Orden Corte ${selectedOrdenCorteDev}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                Swal.fire("Good job!", "Creado con exito", "success");
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          }
        }
      });

      // Terminamos de post a devoluciones acumulado
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

function QRGen(id, codigo, nombre, color, cantidad, unidad) {
  // PDF 10 cm (ancho) x 5 cm (alto) horizontal
  const doc = new jsPDF("l", "mm", [100, 50]);

  // Márgenes y layout
  const M = 4;
  const PAGE_W = 100, PAGE_H = 50;
  const LEFT_COL_W = 60; // ancho de columna para texto
  const RIGHT_COL_X = M + LEFT_COL_W + 2;

  // Logos (arriba izquierda)
  try {
    const logo1 = new Image();
    logo1.src = process.env.PUBLIC_URL + "Logo-Lynqro-Negro.png";
    doc.addImage(logo1, "PNG", M, M, 22, 6);
  } catch (_) {}

  try {
    const logo2 = new Image();
    logo2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(logo2, "PNG", M, M + 7.5, 22, 8);
  } catch (_) {}

  // QR (arriba derecha)
  const base64 = qrcode.toDataURL(String(id ?? ""));
  const qrSize = 30;
  doc.addImage(base64, "PNG", RIGHT_COL_X, M, qrSize, qrSize);

  // Datos en vertical (columna izquierda)
  const wrap = (txt, maxW) => doc.splitTextToSize(String(txt ?? ""), maxW);
  let y = M + 20; // empieza debajo de los logos
  const step = 4;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(wrap(`Cod: ${codigo}`, LEFT_COL_W), M, y); y += step;
  doc.text(wrap(`Mod: ${nombre}`, LEFT_COL_W), M, y); y += step;
  doc.text(wrap(`Color: ${color}`, LEFT_COL_W), M, y); y += step;
  doc.text(wrap(`ID: ${id}`, LEFT_COL_W), M, y); y += step + 2;

  // Cantidad: debajo del QR (derecha), negrita, sin "Cant." (como ListadoCompras)
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  const cantTxt = `${cantidad ?? ""} ${unidad ?? ""}`.trim();
  const qrCenterX = RIGHT_COL_X + 15;
  const cantY = M + 30 + 7;
  doc.text(cantTxt, qrCenterX, cantY, { align: "center" });

  // Descargar directamente
  // doc.save(`QR.pdf`);

  // O abrir en una pestaña nueva
  window.open(doc.output("bloburl"), "_blank");
}


  let totalCantidadMt = 0;
  let totalCantidadKg = 0;
  async function PDFTelas(numero, fecha, pedido, id, total_piezas, cliente, articulo
    // , patronista
  ) {

    let temp2 = [];
    await axios
        .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, {
            headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
        })
        .then(async (response) => {
            let allArticulosOrdenCorte = response.data;
            let colorTallaCantidad = {};

            allArticulosOrdenCorte.forEach((a) => {
                const color = a.colores[0].name;
                const talla = a.tallas[0].name;
                const cantidad = a.cantidad;

                if (!colorTallaCantidad[talla]) {
                    colorTallaCantidad[talla] = {};
                }
                if (!colorTallaCantidad[talla][color]) {
                    colorTallaCantidad[talla][color] = 0;
                }
                colorTallaCantidad[talla][color] += cantidad;
            });

            const tallas = Object.keys(colorTallaCantidad).sort((a, b) => {
              const indexA = ordenTallas.indexOf(a);
              const indexB = ordenTallas.indexOf(b);
            
              // Si alguna talla no está en el orden definido, coloca al final
              return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
            });
            const colores = [
                ...new Set(allArticulosOrdenCorte.map((a) => a.colores[0].name)),
            ].sort();



    await axios
    .get(`${URL_INVENTARIOS_TELAS}/ordenCorte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async (response) => {
        let allArticulosOrdenCorte = response.data;
        let arrayTabla = allArticulosOrdenCorte
          .map((a) => {
            if (a.unidad == "Metros") {
              totalCantidadMt = totalCantidadMt + a.cantidad;
            } else {
              totalCantidadKg = totalCantidadKg + a.cantidad;
            }
            return {
              id: a._id,
              articulo: a.articulo,
              proveedor: a.proveedor,
              factura: a.factura,
              cantidad: a.cantidad,
              cantidadSobrante: a.cantidadSobrante,
              unidad: a.unidad,
              idTela: a.idTela,
              telaNombre: a.articulo,
              colorNombre: a.colorNombre,
              idColor: a.idColor,
              cantidadString: a.cantidadString,
              precio: a.precio,
            };
          })
          .filter(function (el) {
            return el != null;
          });

          let dataFinal = Object.values(arrayTabla);
     

          let mts = dataFinal.filter((e) => e.unidad == "Metros");
          let totalMts = mts.map((c) => parseFloat(c.cantidad));
          let TM = totalMts.reduce((t, total, index) => t + total, 0);

          let KG = dataFinal.filter((e) => e.unidad == "Kilos");
          let totalKG = KG.map((c) => parseFloat(c.cantidad));
          let TK = totalKG.reduce((t, total, index) => t + total, 0);

        const data = dataFinal
        .sort((a, b) => (a.colorNombre < b.colorNombre ? 1 : -1))
        .map((a) => {
          return [
            a.proveedor,
            a.articulo,
            a.colorNombre,
            "$" + new Intl.NumberFormat("en-US").format(a.precio),
            a.factura,
            new Intl.NumberFormat("en-US").format(a.cantidad) + " " + a.unidad,
            new Intl.NumberFormat("en-US").format(a.cantidad / total_piezas),
            new Intl.NumberFormat("en-US").format(a.cantidadSobrante),
            a.cantidadString,
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
             // Observaciones de telas
         await axios
      .get(`${URL_TELAS_ORDENES_CORTE}/ordenCorte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allObservacionesTela = response.data;
        // Array para pagination
        let observTela = allObservacionesTela
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              observaciones: a.observaciones,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinalSobrante = Object.values(observTela);
        setObservacionesTelasPDF(dataFinalSobrante[0].observaciones)
        })


        const doc = new jsPDF("landscape");
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 230, 30, 45, 15);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 120, 7, 60, 25);
        doc.text(`Salida Tela OP # ${numero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha OC: ${fecha}`, 20, 25);
        doc.text(`Cantidad: ${(totalCantidadMt).toFixed(2)} Mts ${(totalCantidadKg.toFixed(2))} Kgs`, 20, 30);
        doc.text(`Modelo: ${articulo}`, 20, 35);
        doc.text(`Observaciones: ${observacionesTelasPDF}`, 20, 40);

        doc.text(`Pedido: ${pedido}`, 180, 20);
        doc.text(`Cliente: ${cliente}`, 180, 25);
        // doc.text(`Patronista: ${patronista}`, 180, 30);
        doc.text(`Piezas: ${(total_piezas)}`, 180, 30);



         // Crear una variable para almacenar todas las filas de datos
         const bodyData = [];

         // Iterar sobre las tallas
         tallas.forEach((talla) => {
             let rowData = [talla];
             let totalTalla = 0;

             // Iterar sobre los colores
             colores.forEach((color) => {
                 const cantidad = colorTallaCantidad[talla][color] || 0;
                 rowData.push(cantidad);
                 totalTalla += cantidad;
             });

             // Agregar el total por talla al final de la fila
             rowData.push(totalTalla);

             // Agregar la fila de datos al conjunto de datos del cuerpo
             bodyData.push(rowData);
         });

         // Calcular y agregar totales por color en una fila al final de la tabla
         const totalesColorRow = ["Total"];
         let totalGeneral = 0; // Inicializar el total general
         colores.forEach((color) => {
             let totalColor = 0;
             tallas.forEach((talla) => {
                 totalColor += colorTallaCantidad[talla][color] || 0;
             });
             totalesColorRow.push(totalColor);
             totalGeneral += totalColor; // Sumar al total general
         });

         // Agregar el total general al final de la fila de totales
         totalesColorRow.push(totalGeneral);

         // Agregar totalesColorRow al final de bodyData
         bodyData.push(totalesColorRow);

         // Generar la tabla con todos los datos del cuerpo y los estilos definidos fuera del bucle
         doc.autoTable({
             head: [["Tallas", ...colores, "Total"]],
             body: bodyData, // Utilizar el conjunto de datos del cuerpo
             startY: 45,
             styles: {
                 fontSize: 10,
                 cellPadding: 0.7,
                 valign: "middle",
                 halign: "center",
             }, // Estilos generales de las celdas
             headStyles: {
                 fillColor: [41, 128, 186],
                 textColor: [255, 255, 255],
                 fontStyle: "bold",
                 halign: "center",
             }, // Estilos para el encabezado
         });


        doc.autoTable({
          head: [
            [
              "Proveedor",
              "Articulo",
              "Color",
              "Precio",
              "Factura",
              "Cantidad",
              "Consumo",
              "Sobrante",
              "Rollos"
            ],
          ],
          body: dataPDFLimpia,
          startY: doc.autoTable.previous.finalY + 13,
          foot: [[]],
          showFoot: "lastPage",
        });
        // doc.save(`OrdenCorte-${numero}.pdf`);
        window.open(doc.output("bloburl"), "_blank");
      })
      .catch((err) => {
        console.log(err);
      });
        })
        .catch((err) => {
            console.log(err);
        });
  }

  async function PDFTelasDetalles(numero, fecha, pedido, id, total_piezas, cliente, articulo
    // , patronista
  ) {
    await axios
      .get(`${URL_INVENTARIOS_TELAS}/ordenCorteDetalle/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            return {
              id: a._id,
              articulo: a.articulo,
              proveedor: a.proveedor,
              factura: a.factura,
              cantidad: a.cantidad,
              cantidadSobrante: a.cantidadSobrante,
              unidad: a.unidad,
              idTela: a.idTela,
              telaNombre: a.articulo,
              colorNombre: a.colorNombre,
              idColor: a.idColor,
              cantidadString: a.cant
            };
          })
          .filter(function (el) {
            return el != null;
          });
                let dataFinal = Object.values(arrayTabla);


                const data = dataFinal.map((a) => {
                  return [
                    a.id,
                    a.telaNombre,
                    a.colorNombre,
                    new Intl.NumberFormat("en-US").format(a.cantidad) + " " + a.unidad,
                  ];
                });

                const dataPDF = Object.values(data);
                const dataPDFLimpia = dataPDF.filter(function (el) {
                  return el != null;
                });
                const doc = new jsPDF("landscape");
                var img = new Image();
                img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
                doc.addImage(img, "png", 230, 30, 45, 15);
                var img2 = new Image();
                img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
                doc.addImage(img2, "png", 120, 7, 60, 25);
                doc.text(`Salida Tela OP # ${numero}`, 20, 20);
                doc.setFontSize(12);
                doc.text(`Fecha OC: ${fecha}`, 20, 25);
                doc.text(`Cantidad: ${(totalCantidadMt).toFixed(2)} Mts ${(totalCantidadKg.toFixed(2))} Kgs`, 20, 30);
                doc.text(`Modelo: ${articulo}`, 20, 35);
                doc.text(`Observaciones: ${observacionesTelasPDF}`, 20, 40);

                doc.text(`Pedido: ${pedido}`, 180, 20);
                doc.text(`Cliente: ${cliente}`, 180, 25);
                // doc.text(`Patronista: ${patronista}`, 180, 30);
                doc.text(`Piezas: ${(total_piezas)}`, 180, 30);
                doc.autoTable({
                  head: [
                    [
                      "id",
                      "Tela",
                      "Color",
                      "Cantidad",
                    ],
                  ],
                  body: dataPDFLimpia,
                  startY: 60,
                  showFoot: "lastPage",
                });

                // doc.save(`Nota-${numero}.pdf`);
        window.open(doc.output("bloburl"), "_blank");
            //   }
            // });
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function BuscaRollo(id, event) {
    if (event.target.value.length >= 24) {
      if (inventarios.filter((e) => e._id == event.target.value)
      .length > 0)  {
      if (
        (inputFields.filter((e) => e.idInventarioTelas == event.target.value)
          .length > 0) 
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El rollo ya fue escaneado!",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.idInventarioTelas = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      } else {
        inventarios.map((a) => {
          if (a._id == event.target.value) {
            let idInventarioTelas = a._id;
            let telas = a.telas[0].nombre;
            let idTela = a.telas[0]._id;
            let unidad = a.telas[0].unidad;
            let color = a.colores[0].name;
            let idColor = a.colores[0]._id;
            let cantidad = a.cantidad;
            let telaNombre = a.telas[0].nombre + " / " + a.colores[0].name
            
            handleChangeInputTelas(
              id,
              idInventarioTelas,
              telas,
              idTela,
              unidad,
              color,
              idColor,
              cantidad,
              telaNombre
            );
          }
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El rollo ya fue cortado previamente!",
        showConfirmButton: false,
      });
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = "";
        }
        return i;
      });
      setInputFields(newInputFields);
    }
    } 
    else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  const handleChangeInputTelas = (
    id,
    idInventarioTelas,
    telas,
    idTela,
    unidad,
    color,
    idColor,
    cantidad,
    telaNombre
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idInventarioTelas = idInventarioTelas;
        i.telas = telas;
        i.idTela = idTela;
        i.unidad = unidad;
        i.colores = color;
        i.idColor = idColor;
        i.cantidad = cantidad;
        i.telaNombre = telaNombre;
      }
      return i;
    });

    ActualizaTotalesSurt();
    setInputFields(newInputFields);
    handleAddFields();
  };

  function ActualizaTotalesSurt() {
    let mts = inputFields.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFields.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["idArticulo"] + item["idColor"] + item["idTela"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        idColor: item.idColor,
        idTela: item.idTela,
        cantidad: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val].telas = item.telas;
      groups[val].idTela = item.idTela;
      groups[val].idArticulo = item.idArticulo;
      groups[val].unidad = item.unidad;
      groups[val].idColor = item.idColor;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);
    let tr = 0;
    inputFields.map((a) => {
      if (a.idArticulo != "") {
        return (tr = tr + 1);
      }
    });
    setRollosTotales(tr);
  }

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];

    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idInventarioTelas: "",
        telas: "",
        idTela: "",
        unidad: "",
        colores: "",
        idColor: "",
        cantidad: 0,
        idArticulo: ultimo.idArticulo,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let mts = values.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = values.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);
  };

  const handleChangeInputArticulo = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idArticulo = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const saveTelas = async (event) => {
    event.preventDefault();
    if (fechaTelas != "" && observacionesTelas != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = inputFields.length + cantidadAgrupado.length;
      try {
        await axios
          .post(
            URL_TELAS_ORDENES_CORTE,
            {
              fecha: fechaTelas,
              ordenesCorte: selectedOrdenCorte,
              observaciones: observacionesTelas,
              totalMetros,
              totalKilos,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            inputFields.map((a) => {
              if (a.idTela != "") {
                axios
                  .patch(
                    `${URL_INVENTARIOS_TELAS}/ordenesCorte/${a.idInventarioTelas}`,
                    {
                      ordenesCorte: selectedOrdenCorte,
                      fechaCorte: fechaTelas,
                      produccion: "Si",
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    totalRollos = totalRollos - 1;
                    if (totalRollos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Telas Ordenes Corte",
                            detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  });
              } else {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Telas Ordenes Corte",
                        detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              }
            });

            // Pegamos a Apartados Acumulado

            cantidadAgrupado.map((w) => {
              axios
                .post(
                  `${URL_TELAS_ORDENES_CORTES_ACUMULADOS}`,
                  {
                    telasOrdenesCorte: data.data._id,
                    articulos: w.idArticulo,
                    telas: w.idTela,
                    colores: w.idColor,
                    cantidad: w.cantidad,
                    ordenesCorte: selectedOrdenCorte,
                    fecha: fechaTelas
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalRollos = totalRollos - 1;
                  if (totalRollos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Telas Ordenes Corte",
                          detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            });

            // Terminamos de post a apartados acumulado
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  function cortado(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se marcará como cortado!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Marcar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_CORTE}/${id}`,
            {
              cortado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.cortado = "Si";
              }
              return i;
            });
            setComments(newComments);

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Cerró",
              showConfirmButton: false,
              timer: 1000,
            });

            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  function noCortado(id) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se marcará como no cortado!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Marcar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ORDENES_CORTE}/${id}`,
            {
              cortado: "No",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            const newComments = comments.map((i) => {
              if (id === i._id) {
                i.cortado = "No";
              }
              return i;
            });
            setComments(newComments);

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Abrió",
              showConfirmButton: false,
              timer: 1000,
            });

            // setTimeout(() => {
            //   window.location.reload();
            // }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  }

  async function jalaEdit(id, numero){
    setIdEdit(id)

    await axios
    .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${id}`, {
        headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
    }).then((response) => {
      let allArticulos = response.data;
      let array = allArticulos.map((a) => {
        return {
          _id: a._id,
          cantidad: a.cantidad,
          cortado: a.cortado,
          pendiente_cortar: a.pendiente_cortar,
          articulo: a.articulos[0].codigo + " " + a.articulos[0].descripcion,
          idArticulo: a.articulos[0]._id,
          color: a.colores[0].name,
          idColor: a.colores[0]._id,
          talla:
  a.tallas[0].name +
  (a.tallas[0].variantesTallas?.[0]?.name
    ? " " + a.tallas[0].variantesTallas[0].name
    : ""),
          idTalla: a.tallas[0]._id,
        };
      })
      let data = Object.values(array);

      setArticulosEdit(data);

      let totalMts = data.map((c) => parseFloat(c.cantidad));
      let TM = totalMts.reduce((t, total, index) => t + total, 0);
      setTotalPiezas(TM);
      toggleEdit()
    }).catch((err) => {
        console.log(err);
    })

  }

  const sortedArticulosEdit = [...articulosEdit].sort((a, b) => {
    // Primero ordenar por color
    if (a.color > b.color) return 1;
    if (a.color < b.color) return -1;
  
    // Si los color son iguales, ordenar por el orden de tallas
    const indexA = ordenTallas.indexOf(a.talla);
    const indexB = ordenTallas.indexOf(b.talla);
  
    // Si ambas tallas están en el orden definido
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
  
    // Si alguna talla no está en el orden definido, ponerla al final
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
  
    return 0;
  });
  
  const handleChangeInputCantidadEdit = (id, event) => {
    const newArticulosEdit = articulosEdit.map((i) => {
      if (id === i._id) {
        i.cantidad = parseFloat(event.target.value);
      }
      return i;
    });
    setArticulosEdit(newArticulosEdit);

    ActualizaTotales();
  };

  function ActualizaTotales() {
    let totalMts = articulosEdit.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TM);
  }

 async function saveEdit() {
   let tot = articulosEdit.length;
   await axios
     .patch(
       `${URL_ORDENES_CORTE}/${idEdit}`,
       {
         cantidad: total_piezas,
       },
       {
         headers: {
           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
         },
       }
     )
     .then(() => {
       articulosEdit.map((a) => {
         axios
           .patch(
             `${URL_ARTICULOS_ORDENES_CORTE}/${a._id}`,
             {
               cantidad: a.cantidad,
             },
             {
               headers: {
                 Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
               },
             }
           )
           .then(() => {
             tot = tot - 1;
             if (tot == 0) {
               Swal.fire("Good job!", "Creado con exito", "success");
               setTimeout(() => {
                 window.location.reload();
               }, 1000);
             }
           })
           .catch((error) => {
             console.log(error);
           });
       });
     })
     .catch((err) => {
       console.log(err);
     });
 }


   function jalaHabilitacion(
    id,
    idArticulo,
    idPedido,
    idCorte,
  ) {
    setIdProcesosSalidaHab(id);
    setIdCorteHab(idCorte);
    setIdPedidoHab(idPedido);

    axios
    .get(`${URL_EXPLOSION}Articulo/${idArticulo}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allArticulosOrdenCorte = response.data;
      let arrayTabla = allArticulosOrdenCorte
        .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
        .map((a) => {
          return {
            id: uuidv4(),
            idHabilitacion: a.habilitacion[0]._id,
            // nombre: a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
            // cantidadAnterior: a.cantidad,
            cantidad: 0,
          }
        })
        .filter(function (el) {
          return el != null;
        });

      const data = Object.values(arrayTabla);
      setInputFieldsHabilitacion(data);
    })
    .catch((err) => {
      console.log(err);
    });



    toggleHabilitacion();
  }

  function saveHabilitacion(event) {
    event.preventDefault();
    let totalRollos = inputFieldsHabilitacion.length;
    axios
      .post(
        URL_HABILITACION_ORDENES_CORTES,
        {
          ordenesCorte: idCorteHab,
          pedidos: idPedidoHab,
          fecha: fechaHab,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((data2) => {
        inputFieldsHabilitacion.map((a) => {
          if (a.cantidad != 0) {
            axios
              .post(
                URL_DETALLE_HABILITACION_ORDENES_CORTES,
                {
                  cantidad: a.cantidad,
                  habilitacionOrdenesCortes: data2.data._id,
                  ordenesCorte: idCorteHab,
                  pedidos: idPedidoHab,
                  habilitacion: a.idHabilitacion,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Salida de Habilitacion",
                        detalle: `Pedido ${idPedidoHab}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              });
          } else {
            totalRollos = totalRollos - 1;
            if (totalRollos == 0) {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Salida de Habilitacion",
                    detalle: `Pedido ${idPedidoHab}`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  Swal.fire("Good job!", "Creado con exito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            }
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  const handleChangeInputHabilitacion = (id, event) => {
    const newInputFieldsHabilitacion = inputFieldsHabilitacion.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsHabilitacion(newInputFieldsHabilitacion);
  };

  const handleRemoveFieldsHabilitaccion = (id) => {
    const values = [...inputFieldsHabilitacion];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFieldsHabilitacion(values);
  };

  const handleAddFieldsHabilitacion = () => {
    setInputFieldsHabilitacion([
      ...inputFieldsHabilitacion,
      {
        id: uuidv4(),
        idHabilitacion: "",
        cantidad: 0,
      },
    ]);
  };

   function jalaHabilitacionEdit(id) {
  axios
    .get(`${URL_DETALLE_HABILITACION_ORDENES_CORTES}/proceso/${id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allArticulosOrdenCorte = response.data;
      let arrayTabla = allArticulosOrdenCorte
        .sort((a, b) => (a.idProcesosSalida < b.idProcesosSalida ? 1 : -1))
        .map((a) => {
          return {
            id: a._id,
            idHabilitacion: a.habilitacion[0]._id,
            nombre: a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
            cantidadAnterior: a.cantidad,
            cantidad: a.cantidad,
            observaciones: a.habilitacionOrdenesCortes[0].observaciones,
          };
        })
        .filter((el) => el != null);

      const data = Object.values(arrayTabla);
      setEditHab(data);

      if (data.length > 0) {
        setObservacionesHab(data[0].observaciones);
      }

      toggleEditHab();
    })
    .catch((err) => {
      console.log(err);
    });
}


  const handleChangeInputHabilitacionEdit = (id, event) => {
    const newInputFieldsHabilitacion = editHab.map((i) => {
      if (id === i.id) {
        i.cantidad = parseFloat(event.target.value);
      }
      return i;
    });
    setEditHab(newInputFieldsHabilitacion);
  };

  function saveHabilitacionEdit(event) {
    event.preventDefault();
    let totalRollos = editHab.length;
        editHab.map((a) => {
            axios
              .patch(
                `${URL_DETALLE_HABILITACION_ORDENES_CORTES}/${a.id}`,
                {
                  habilitacion: a.idHabilitacion,
                  cantidad: a.cantidad,
                  cantidadAnterior: a.cantidadAnterior,
                  observaciones: observacionesHab,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Editar Salida de Habilitacion",
                        detalle: `Pedido`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              });
        });
  }

    async function PDFOCHab(
      numero,
      cliente,
      fecha,
      pedido,
      idPedidos,
      articuloCodigo,
      articuloDescripcion,
      idArticulo,
      totalPiezas,
      observaciones,
      idPDFOC
    ) {
  const getImageAsDataURL = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        } catch (e) {
          reject(e);
        }
      };
      img.onerror = reject;
      img.src = url;
    });
  };

  try {
    const { data: allArticulosOrdenCorte } = await axios.get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${idPDFOC}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    });

    const doc = new jsPDF();
    const logo = new Image();
    logo.src = process.env.PUBLIC_URL + "logoInstitucion.png";

    await new Promise((resolve) => {
      logo.onload = () => {
        const scale = 30 / logo.height;
        doc.addImage(
          logo,
          "png",
          (doc.internal.pageSize.getWidth() - logo.width * scale) / 2,
          10,
          logo.width * scale,
          logo.height * scale
        );
        resolve();
      };
    });

    doc.setFontSize(12);
    doc.text(`Orden de Produccion # ${numero}, Fecha ${fecha}`, 15, 50);
    doc.text(`Pedido ${pedido}, Cliente ${cliente}`, 15, 55);
    doc.text(`Observaciones ${observaciones}`, 15, 60);
    doc.text(`Modelo ${articuloCodigo} ${articuloDescripcion}`, 15, 65);
    let currentY = 80;

    const grupoPorSucursalAreaArticulo = {};
    allArticulosOrdenCorte.forEach((a) => {
      const sucursal = a.sucursales?.[0]?.alias || "Sin Sucursal";
      const area = a.areasClientes?.[0]?.name || "Sin Área";
      const articulo = a.articulos?.[0]?.descripcion || "Sin Artículo";
      const clave = `${sucursal}||${area}||${articulo}`;
      if (!grupoPorSucursalAreaArticulo[clave]) grupoPorSucursalAreaArticulo[clave] = [];
      grupoPorSucursalAreaArticulo[clave].push(a);
    });

    for (const clave in grupoPorSucursalAreaArticulo) {
      const grupo = grupoPorSucursalAreaArticulo[clave];
      const [sucursal, area, articulo] = clave.split("||");

      doc.setFontSize(11);
      doc.setFont(undefined, "bold");
      doc.text(`Sucursal: ${sucursal}`, 20, currentY);
      currentY += 6;
      doc.text(`Área: ${area}`, 20, currentY);
      currentY += 6;
      doc.text(`Modelo: ${articulo}`, 20, currentY);
      currentY += 6;

      const agrupadoPorColor = {};
      const tallasSet = new Set();

      grupo.forEach((a) => {
        const color = a.colores?.[0]?.name || "Sin Color";
        const talla = a.tallas?.[0]?.name?.trim() || "Sin Talla";
        const variante = a.tallas?.[0]?.variantesTallas[0]?.name?.trim() || "";
        const key = talla;
        const detalle = variante ? `(${variante})` : "";

        if (!agrupadoPorColor[color]) agrupadoPorColor[color] = {};
        if (!agrupadoPorColor[color][key]) agrupadoPorColor[color][key] = [];
        agrupadoPorColor[color][key].push({ cantidad: a.cantidad, detalle });
        tallasSet.add(key);
      });

      const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];;
      const tallas = Array.from(tallasSet).sort((a, b) => {
        const indexA = ordenTallas.indexOf(a);
        const indexB = ordenTallas.indexOf(b);
        return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
      });

      const head = [["Color", ...tallas, "Total"]];
      const body = [];

      for (const color of Object.keys(agrupadoPorColor)) {
        let totalColor = 0;
        const row = [color];
        for (const talla of tallas) {
          const celdas = agrupadoPorColor[color][talla] || [];
          let celdaTexto = "";
          let subtotal = 0;
          celdas.forEach(({ cantidad, detalle }) => {
            celdaTexto += `${cantidad} ${detalle}\n`;
            subtotal += cantidad;
          });
          row.push(celdaTexto.trim());
          totalColor += subtotal;
        }
        row.push(totalColor);
        body.push(row);
      }

      doc.autoTable({
        head,
        body,
        startY: currentY,
        styles: { fontSize: 9, cellPadding: 0.8, valign: "middle", halign: "center", cellWidth: 'wrap', overflow: 'linebreak' },
        headStyles: { fillColor: [41, 128, 186], textColor: [255, 255, 255], fontStyle: "bold" },
      });

      currentY = doc.autoTable.previous.finalY + 8;

      // Mostrar bordados agrupados por articuloPedido (no repetidos por talla/color)
      const bordadosMap = new Map();

      grupo.forEach((a) => {
        const ap = a.articulosPedido?.[0];
        if (ap && ap._id && ap.bordados?.length > 0 && !bordadosMap.has(ap._id)) {
          bordadosMap.set(ap._id, ap.bordados);
        }
      });

// Mostrar bordados una sola vez por grupo (no repetir por talla/color)
const primer = grupo.find((a) => a.articulosPedido?.[0]?.bordados?.length > 0);
const bordados = primer?.articulosPedido?.[0]?.bordados || [];

if (bordados.length) {
  doc.setFont(undefined, "bold");
  doc.setFontSize(10);
  doc.text("Bordados:", 20, currentY);
  currentY += 5;

  let currentX = 20;
  let maxYInRow = 0;
  const imageMargin = 5;
  // x3: bordados 3 veces más grandes (2026-06)
  const maxImageHeight = 10 * 3;
  const maxImageWidth = 15 * 3;

  for (const b of bordados) {
    try {
      const url = `https://res.cloudinary.com/lynqro/image/upload/${b.public_id}`;
      const dataUrl = await getImageAsDataURL(url);

      const img = new Image();
      img.src = dataUrl;
      await new Promise((resolve) => {
        img.onload = () => {
          const ratio = Math.min(maxImageWidth / img.width, maxImageHeight / img.height);
          const imgW = img.width * ratio;
          const imgH = img.height * ratio;

          if (currentX + imgW > doc.internal.pageSize.getWidth() - 20) {
            currentX = 20;
            currentY += maxYInRow + 15;
            maxYInRow = 0;
          }

          doc.addImage(dataUrl, "PNG", currentX, currentY, imgW, imgH);
          doc.setFont(undefined, "normal");
          doc.setFontSize(10);
          doc.text(b.observacion || "", currentX, currentY + imgH + 4, { maxWidth: imgW });

          maxYInRow = Math.max(maxYInRow, imgH + 10);
          currentX += imgW + imageMargin;
          resolve();
        };
      });
    } catch (err) {
      console.warn("No se pudo cargar bordado:", b.public_id);
    }
  }

  currentY += maxYInRow + 10;
}


      if (currentY > 270) {
        doc.addPage();
        currentY = 20;
      }
    }

    window.open(doc.output("bloburl"), "_blank");
  } catch (err) {
    console.error("Error generando PDF:", err);
    Swal.fire("Error", "No se pudo generar el PDF", "error");
  }
    }

      const saveTelasConsumo = async (event) => {
    event.preventDefault();
    if (fechaTelas != "" && observacionesTelas != "") {
      setValidaBoton(false);
      toggleProgreso();

      let totalRollos = inputFieldsAnteriorConsumo.length
      try {
      
        inputFieldsAnteriorConsumo.map((w) => {
              axios
                .patch(
                  `${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/${w.id}`,
                  {
                    consumo: w.consumo,
                    piezas: w.piezas,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalRollos = totalRollos - 1;
                  if (totalRollos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Agregar Consumo y Piezas",
                          detalle: `Ordenes Corte ${selectedOrdenCorteNumero}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            });

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };
    function telasCortesConsumo(id, numero) {
    toggleProgreso()
    axios
      .get(`${URL_TELAS_ORDENES_CORTES_ACUMULADOS}/ordenCorte/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInputFieldsAnterior = response.data;
        let tablaTelas = allInputFieldsAnterior.map((a) => {
          return {
            id: a._id,
            articulo:
              a.articulos[0].codigo +
              " / " +
              
              a.articulos[0].descripcion,
            tela: a.telas[0].nombre,
            color: a.colores[0].name,
            unidad: a.telas[0].unidad,
            cantidad: a.cantidad,
            telaNombre: a.telas[0].codigo + " / " + a.telas[0].nombre + " / " + a.colores[0].name,
            consumo: a.consumo,
            piezas: a.piezas,
          };
        });
        let dataFinal = Object.values(tablaTelas);

       
        setInputFieldsAnteriorConsumo(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

    setSelectedOrdenCorte(id);
    setSelectedOrdenCorteNumero(numero);
    setTimeout(() => {
      toggleTelasConsumo();
      setModalProgreso(false)
    }, 1000);
  }

  const handleChangeInput = (id, event) => {
    const newInventarios = inputFieldsAnteriorConsumo.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
      }
      return i;
    });
    setInputFieldsAnteriorConsumo(newInventarios);
    ActualizaTotales();
};

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.menu_produccion ? (
                <>
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCorteCreate"
                >
                  Nueva Orden
                </Button>
                {/* <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCorteExternoCreate"
                >
                  Nueva Compra
                </Button> */}
                </>
              ) : (
                <>
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva Orden
                </Button>
                {/* <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/OrdenesCorteExternoCreate"
                >
                  Nueva Compra
                </Button> */}
                </>
              )}
              <Button
                size="sm"
                href="/MenuProduccion"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ordenes de Corte Acumuladas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Ordenes de Corte Acumuladas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio (Pedido)</Label>
              <Input
                // bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin (Pedido)</Label>
              <Input
                // bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <div className="table-wrapper">
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCliente}
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="0">Selecciona</option>
                  {articulos
                    .sort((a, b) =>
                      a.codigoCliente > b.codigoCliente ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          Cod: {a.codigoCliente} / Ref: {a.codigo} / Desc:{" "}
                          {a.descripcion}
                        </option>
                      );
                    })}
                </Input>
              </td> */}

{/* <td></td>
<td></td>
<td></td>
<td></td>
<td></td> */}
              {/* <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCortado}
                  onChange={(e) => {
                    setSelectedCortado(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </td> */}
            </tr>

            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr
                      style={
                        a.is_active == "No"
                          ? { backgroundColor: "#ed8c8c" }
                          // : a.pedidoEditado == "Si"
                          // ? { backgroundColor: "#ffff00" }
                          : undefined
                      }
                    >
                      {/* <td>{a.numero}</td> */}
                      <td>{a.pedido}</td>
                      <td>{a.fecha}</td>
                      <td>{a.cliente}</td>
                      {/* <td>{a.articulo}</td>
                      <td>{a.statusTela}</td> */}
                      <td>{a.observaciones}</td>
                      <td>{a.fechaCancelacion}</td>
                      {/* <td>{a.total_piezas}</td> */}
                      {/* <td>{a.cortado}</td> */}
                      <td>
                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.numero,
                                  a.cliente,
                                  a.fecha,
                                  a.pedido,
                                  a.idPedidos,
                                  a.articuloCodigo,
                                  a.articuloDescripcion,
                                  a.idArticulo,
                                  a.total_piezas,
                                  a.observaciones,
                                  a._id
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                          
                      </td>
                      {/* {a.corteExterno == "Si" ? (
                                            <td>
                        <Button
                          size="sm"
                          className="btn"
                          color="success"
                          onClick={(e) =>
                            jalaHabilitacion(
                              a.id,
                              a.idArticulo,
                              a.idPedidos,
                              a._id
                            )
                          }
                        >
                          <i class="fas fa-tag"></i>
                        </Button>
                        <Button
                          color="info"
                          id="Editar"
                          size="sm"
                          onClick={(e) => {
                            jalaHabilitacionEdit(a._id);
                          }}
                        >
                          <i class="far fa-edit"></i>
                        </Button>
                        <Button
                          size="sm"
                          className="btn"
                          color="danger"
                          onClick={(e) =>
                            PDFOCHab(
                              a.numero,
                                a.cliente,
                                a.fecha,
                                a.pedido,
                                a.idPedidos,
                                a.articuloCodigo,
                                a.articuloDescripcion,
                                a.idArticulo,
                                a.total_piezas,
                                a.observaciones,
                                a._id
                            )
                          }
                        >
                          <i class="far fa-file-pdf"></i>
                        </Button>
                      </td>
                      ) : (
                        <td></td>)} */}
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          </div>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios minutos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalTelas} toggle={toggleTelas}>
        <ModalHeader toggle={toggleTelas}>
          <h4>
            Entrega de Tela de la Orden de Produccion {selectedOrdenCorteNumero}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelas}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaTelas}
                  required
                  onChange={(e) => {
                    setFechaTelas(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observacionesTelas}
                  required
                  onChange={(e) => {
                    setObservacionesTelas(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <br />
            {inputFieldsAnterior != "" ? (
              <>
                <Label>Tela Asignada</Label>
                <Row>
                  <Col md={2}>
                    <Label className="mr-sm-2">Articulo</Label>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Tela</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Color</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Unidad</Label>
                  </Col>
                  <Col md={1}>
                    <Label className="mr-sm-2">Cantidad</Label>
                  </Col>
                </Row>

                {inputFieldsAnterior.map((inputFieldAnt) => (
                  <div key={inputFieldAnt.id}>
                    <Row>
                      <Col md={2}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.articulo}
                          disabled
                        />
                      </Col>
                      <Col md={3}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.telaNombre}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.color}
                          disabled
                        />
                      </Col>
                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.unidad}
                          disabled
                        />
                      </Col>

                      <Col md={1}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputFieldAnt.cantidad}
                          disabled
                        />
                      </Col>
                    </Row>
                  </div>
                ))}
              </>
            ) : undefined}
            <br />

            <Label>Asignar Tela</Label>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.idArticulo}
                      onChange={(event) => {
                        handleChangeInputArticulo(inputField.id, event);
                      }}
                      tabindex="-1"
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a.idArticulo}>
                              {a.articuloNombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="idInventarioTelas"
                      type="text"
                      value={inputField.idInventarioTelas}
                      onChange={(event) => {
                        BuscaRollo(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                      <Col md={3}>
                        <Input
                          // bsSize="sm"
                          name="articulos"
                          type="text"
                          value={inputField.telaNombre}
                          disabled
                        />
                      </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="unidad"
                      type="text"
                      value={inputField.unidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="text"
                      value={inputField.cantidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(totalKilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(totalMetros)}{" "}
                  mts. / {rollosTotales} Rollos
                </h4>
              </Col>
            </Row>
            <br />

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalTelasDev} toggle={toggleTelasDev}>
        <ModalHeader toggle={toggleTelasDev}>
          <h4>
            Devolucion de Tela de la Orden de Produccion{" "}
            {selectedOrdenCorteNumeroDev}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelasDev}>
            {/* <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fechaTelas}
                  required
                  onChange={(e) => {
                    setFechaTelas(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observacionesTelas}
                  required
                  onChange={(e) => {
                    setObservacionesTelas(e.target.value);
                  }}
                />
              </Col>
            </Row> */}
            {/* <br />

            <Label>Devolver Tela</Label> */}
            <Row>
              {/* <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col> */}
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad Original</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Cant a Devolver</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  {/* <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.idArticulo}
                      onChange={(event) => {
                        handleChangeInputArticulo(inputField.id, event);
                      }}
                      tabindex="-1"
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosUnicos
                        .sort((a, b) =>
                          a.articuloNombre > b.articuloNombre ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a.idArticulo}>
                              {a.articuloNombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col> */}
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="idInventarioTelas"
                      type="text"
                      value={inputField.idInventarioTelas}
                      onChange={(event) => {
                        BuscaRolloDev(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="tela"
                      type="text"
                      value={inputField.telas}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="unidad"
                      type="text"
                      value={inputField.unidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="text"
                      value={inputField.cantidadOriginal}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="cantidad"
                      type="text"
                      value={inputField.cantidad}
                      required
                      onChange={(event) =>
                        handleChangeInputCantidad(inputField.id, event)
                      }
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(totalKilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(totalMetros)}{" "}
                  mts. / {rollosTotalesDev} Rollos
                </h4>
              </Col>
            </Row>
            <br />

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>

      <Modal size="lg" isOpen={modalExplosion} toggle={toggleExplosion}>
        <ModalHeader toggle={toggleExplosion}>
          <h4>Explosion</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <tr>
              <th>Articulo</th>
              <th>Material</th>
              <th>Color</th>
              <th>Cantidad</th>
              <th>Total Cant</th>
            </tr>
            {explosion.map((a) => (
              <tr>
                <td>{a.articulosCodigo}</td>
                <td>{a.material}</td>
                <td>{a.coloresName}</td>
                <td>{a.cantidad}</td>
                <td>{a.cantidadTotal}</td>
              </tr>
            ))}
          </Table>
        </ModalBody>
      </Modal>

      <Modal size="xxl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar</h4>
        </ModalHeader>
        <ModalBody>
         
        <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>
            {sortedArticulosEdit.map((inputField) => (
              <div key={inputField._id}>
                <Row>
                  <Col md={3}>
                    <Input
                      // bsSize="sm"
                      name="articulo"
                      type="text"
                      value={inputField.articulo}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={2}>
                    <Input
                      // bsSize="sm"
                      name="color"
                      type="text"
                      value={inputField.color}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="talla"
                      type="text"
                      value={inputField.talla}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      // bsSize="sm"
                      name="tela"
                      type="text"
                      value={inputField.cantidad}
                      onChange={(event) =>
                        handleChangeInputCantidadEdit(
                          inputField._id,
                          event
                        )
                      }
                    ></Input>
                  </Col>
                </Row>
               
              </div>
            ))}
             <Row>
              <Col md={5}></Col>
              <Col md={1}>
                <Label>Total Piezas</Label>
              </Col>
                  <Col md={1}>
                    <Label>{total_piezas}</Label>
                    </Col>
                </Row>
                {validaBoton ? (
              <Button type="submit" className="btn btn-success" onClick={saveEdit}>
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
        </ModalBody>
      </Modal>

        <Modal size="sm" isOpen={modalStatusEdit} toggle={toggleStatusEdit}>
              <ModalHeader toggle={toggleStatusEdit}>
                <h3>Editar Status</h3>
              </ModalHeader>
              <ModalBody>
                <Form 
                onSubmit={saveStatusEdit}
                >
                <Row>
                <Col md={12}>
                      <Label>Status</Label>
                      <Input
                        type="select"
                        value={statusTelaEdit}
                        required
                        onChange={(e) => {
                          setStatusTelaEdit(e.target.value);
                        }}
                      >
                        <option value="Pendiente">Pendiente</option>
                        <option value="Completo">Completo</option>
                        <option value="Incompleto">Incompleto</option>
                      </Input>
                    </Col>
                    </Row>
                  <Row>
                    </Row>
                  <br />
                  {validaBoton ? (
                    <Button type="submit" className="btn btn-success">
                      Guardar
                    </Button>
                  ) : (
                    <Button type="submit" className="btn btn-success" disabled>
                      Guardar
                    </Button>
                  )}
                </Form>
              </ModalBody>
            </Modal>

                    <Modal size="sm" isOpen={modalObservacionesEdit} toggle={toggleObservacionesEdit}>
              <ModalHeader toggle={toggleObservacionesEdit}>
                <h3>Editar Observaciones</h3>
              </ModalHeader>
              <ModalBody>
                <Form 
                onSubmit={saveObservacionesEdit}
                >
                <Row>
                <Col md={12}>
                      <Label>Observaciones</Label>
                      <Input
                        type="textarea"
                        value={observacionesEdit}
                        required
                        onChange={(e) => {
                          setObservacionesEdit(e.target.value);
                        }}
                      />
                    </Col>
                    </Row>
                  <Row>
                    </Row>
                  <br />
                  {validaBoton ? (
                    <Button type="submit" className="btn btn-success">
                      Guardar
                    </Button>
                  ) : (
                    <Button type="submit" className="btn btn-success" disabled>
                      Guardar
                    </Button>
                  )}
                </Form>
              </ModalBody>
            </Modal>


            <Modal size="lg" isOpen={modalHabilitacion} toggle={toggleHabilitacion}>
              <ModalHeader toggle={toggleHabilitacion}>
                <h3>Entregar Habilitacion</h3>
              </ModalHeader>
              <ModalBody>
                <Form onSubmit={saveHabilitacion}>
                  <Row>
                    <Col md={3}>
                      <Label>Fecha</Label>
                      <Input
                        bsSize="sm"
                        type="date"
                        value={fechaHab}
                        onChange={(event) => {
                          setFechaHab(event.target.value);
                        }}
                      ></Input>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={8}>
                      <Label className="mr-sm-2">Material</Label>
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Cantidad</Label>
                    </Col>
                  </Row>
      
                  {inputFieldsHabilitacion.map((inputField) => (
                    <div key={inputField.id}>
                      <Row>
                        <Col md={8}>
                          <Input
                            bsSize="sm"
                            name="idHabilitacion"
                            type="select"
                            value={inputField.idHabilitacion}
                            onChange={(event) => {
                              handleChangeInputHabilitacion(inputField.id, event);
                            }}
                          >
                            <option value="">Selecciona</option>
                            {habilitacion
                              .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1))
                              .map((a) => {
                                return <option value={a._id}>{a.descripcion} {a.nombre}</option>;
                              })}
                          </Input>
                        </Col>
      
                        <Col md={2}>
                          <Input
                            bsSize="sm"
                            name="cantidad"
                            type="string"
                            value={inputField.cantidad}
                            onChange={(event) => {
                              handleChangeInputHabilitacion(inputField.id, event);
                            }}
                          ></Input>
                        </Col>
      
                        <Col>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            disabled={inputFieldsHabilitacion.length === 1}
                            onClick={() =>
                              handleRemoveFieldsHabilitaccion(inputField.id)
                            }
                            tabindex="-1"
                          >
                            <i class="fas fa-minus"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={handleAddFieldsHabilitacion}
                            tabindex="-1"
                          >
                            <i class="fas fa-plus"></i>
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  ))}
                  <br />
                  {validaBoton ? (
                    <Button type="submit" className="btn btn-success">
                      Guardar
                    </Button>
                  ) : (
                    <Button type="submit" className="btn btn-success" disabled>
                      Guardar
                    </Button>
                  )}
                </Form>
              </ModalBody>
            </Modal>

            <Modal size="lg" isOpen={modalEditHab} toggle={toggleEditHab}>
              <ModalHeader toggle={toggleEditHab}>
                <h3>Editar Habilitacion</h3>
              </ModalHeader>
              <ModalBody>
                <Form 
                onSubmit={saveHabilitacionEdit}
                >
                  <Row>
                    <Col md={9}>
                      <Label>Observaiones</Label>
                      <Input
                        bsSize="sm"
                        type="text"
                        value={observacionesHab}
                        onChange={(event) => {
                          setObservacionesHab(event.target.value);
                        }}
                      ></Input>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col md={8}>
                      <Label className="mr-sm-2">Material</Label>
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Cantidad Anterior</Label>
                    </Col>
                    <Col md={2}>
                      <Label className="mr-sm-2">Cantidad Nueva</Label>
                    </Col>
                  </Row>
      
                  {editHab.map((a) => (
                    <div key={a.id}>
                      <Row>
                        <Col md={8}>
                          <Input
                            bsSize="sm"
                            name="nombre"
                            type="string"
                            value={a.nombre}
                            disabled
                          />
                        </Col>
      
                        <Col md={2}>
                          <Input
                            bsSize="sm"
                            name="cantidad"
                            type="string"
                            value={a.cantidadAnterior}
                            disabled
                          />
                        </Col>
                        <Col md={2}>
                          <Input
                            bsSize="sm"
                            name="cantidad"
                            type="string"
                            value={a.cantidad}
                            onChange={(event) => {
                              handleChangeInputHabilitacionEdit(a.id, event);
                            }}
                          ></Input>
                        </Col>
                      </Row>
                    </div>
                  ))}
                  <br />
                  {validaBoton ? (
                    <Button type="submit" className="btn btn-success">
                      Guardar
                    </Button>
                  ) : (
                    <Button type="submit" className="btn btn-success" disabled>
                      Guardar
                    </Button>
                  )}
                </Form>
              </ModalBody>
            </Modal>


                  <Modal size="xxl" isOpen={modalTelasConsumo} toggle={toggleTelasConsumo}>
        <ModalHeader toggle={toggleTelasConsumo}>
          <h4>Agregar Consumo {selectedOrdenCorteNumero}</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={saveTelasConsumo}>
            <Label>Tela Asignada</Label>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Tela</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Consumo</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Piezas</Label>
              </Col>
            </Row>

            {inputFieldsAnteriorConsumo.map((inputFieldAnt) => (
              <div key={inputFieldAnt.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.articulo}
                      disabled
                    />
                  </Col>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.telaNombre}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.color}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.unidad}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="text"
                      value={inputFieldAnt.cantidad}
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="consumo"
                      type="number"
                      value={inputFieldAnt.consumo}
                      onChange={(event) =>
                        handleChangeInput(inputFieldAnt.id, event)
                      }
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="piezas"
                      type="number"
                      value={inputFieldAnt.piezas}
                      onChange={(event) =>
                        handleChangeInput(inputFieldAnt.id, event)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}

            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
          </Form>
        </ModalBody>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoOrdenesCorteAcumuladas;
